<template>
    <div class="saas">
        <indexHeader/>
        <section class="saas-section">
            <div class="container">
                <div class="top-container">
                    <Row>
                        <Col span="12">
                            <div class="text-wrapper">
                                <h3 >帮助企业人员提升IT实战技能</h3>
                                <h4 >猎豹实训平台企业版，提供学、练、测一站式的IT技术学习方案</h4>
                                <div class="btn-groups" >
                                    <Button type="primary" class="btn">
                                        <router-link to="/register" style="color: #ffffff">申请试用</router-link>
                                    </Button>
                                    <Button  class="btn" >
                                        <router-link to="/contact_us">联系我们</router-link>
                                    </Button>
                                </div>
                            </div>
                        </Col>
                        <Col span="12">
                            <div class="img-wrapper">
                                <img src="https://static.shiyanlou.com/frontend/dist/img/f59125a.png">
                            </div>
                        </Col>
                    </Row>
                </div>
                <div class="con-container">
                    <Row :gutter="20">
                        <Col span="6">
                            <img src="https://static.shiyanlou.com/frontend/dist/img/302f5a7.png">
                        </Col>
                        <Col span="6">
                            <img src="https://static.shiyanlou.com/frontend/dist/img/ee5fe5d.png">
                        </Col>
                        <Col span="6">
                            <img src="https://static.shiyanlou.com/frontend/dist/img/c7c074b.png">
                        </Col>
                        <Col span="6">
                            <img src="https://static.shiyanlou.com/frontend/dist/img/6be4388.png">
                        </Col>
                    </Row>
                </div>
                <div class="introduce-container">
                    <div class="saas-presentation">
                        <Row>
                            <Col span="14">
                                <div class="img">
                                    <img  src="https://static.shiyanlou.com/frontend/dist/img/5762dd1.png">
                                </div>
                            </Col>
                            <Col span="10">
                                <div class="text ml70" >
                                    <h4 >专属实验系统</h4>
                                    <div >为企业定制在线实训系统，拥有专属的域名、页面、学习专区。</div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="10">
                                <div class="text mr70" >
                                    <h4 >随时随地动手学习</h4>
                                    <div >
                                        500+门最新的IT技术实践课程，随时随地在线练习，在实战中提高技能。
                                    </div>
                                </div>
                            </Col>
                            <Col span="14">
                                <div class="img img-shadow">
                                    <img  src="../../../static/bg2.jpg">
                                </div>

                            </Col>
                        </Row>
                        <Row>
                            <Col span="14">
                                <div class="img img-shadow">
                                    <img  src="../../../static/bg1.jpg">
                                </div>
                            </Col>
                            <Col span="10">
                                <div class="text ml70" >
                                    <h4 >定制私有课程及路径</h4>
                                    <div >企业可定制课程内容及学习路径，按部门管理学习进度。</div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="10">
                                <div class="text mr70" >
                                    <h4 >轻松了解学习情况</h4>
                                    <div >
                                        实时查看成员的学习进度，下载学习数据报告，真实反馈学习效果。
                                    </div>
                                </div>
                            </Col>
                            <Col span="14">
                                <div class="img">
                                    <img  src="https://static.shiyanlou.com/frontend/dist/img/2eac64f.png">
                                </div>

                            </Col>
                        </Row>
                    </div>
                </div>
                <div class="bottom-container">
                    <h4 class="title" data-v-0329e14f="" data-v-47041b36="">
                        现在为你的企业开通专属的在线实训室
                    </h4>
                    <div class="btn-groups" >
                        <Button type="primary" class="btn">
                            <router-link to="/register" style="color: #ffffff">申请试用</router-link>
                        </Button>
                        <Button  class="btn" >
                            <router-link to="/contact_us">联系我们</router-link>
                        </Button>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import indexHeader from "../newLogin/loginHeader";

    export default {
        name: "company",
        components: {
            indexHeader
        },
    }
</script>

<style scoped lang="less">
    @import "./common";
</style>